import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { dashboardAll } from "../routes/index";
import { pageInfo } from "../routes/families";

// En-tête de page automatique (refonte 10/2026) : famille du menu en petit + titre de la page.
// Purement visuel, ajouté AU-DESSUS de chaque page ; le contenu des pages n'est pas modifié.
// Si la page affiche déjà son propre titre en haut (titre de carte, h1…h3), le titre automatique
// s'efface pour ne pas doubler ; la ligne de famille reste. L'accueil garde son « Bienvenue … ».
const OWN_TITLE = "h1, h2, h3, .card-title, .card-header h5";

const PageHeader = withRouter(({ location }) => {
  const path = location.pathname;
  const ref = useRef(null);
  const [ownTitle, setOwnTitle] = useState(false);

  useEffect(() => {
    setOwnTitle(false);
    const header = ref.current;
    if (!header) return undefined;
    const content = header.parentElement;
    const check = () => {
      const limit = header.getBoundingClientRect().bottom + 200;
      const found = Array.from(content.querySelectorAll(OWN_TITLE)).some(
        (el) => !header.contains(el) && !el.closest(".modal") && el.getBoundingClientRect().top < limit && el.textContent.trim() !== ""
      );
      if (found) setOwnTitle(true);
      return found;
    };
    if (check()) return undefined;
    // Les pages chargent leurs données après coup : on observe quelques secondes seulement.
    const observer = new MutationObserver(() => { if (check()) observer.disconnect(); });
    observer.observe(content, { childList: true, subtree: true });
    const timer = setTimeout(() => observer.disconnect(), 5000);
    return () => { observer.disconnect(); clearTimeout(timer); };
  }, [path]);

  if (path === "/" || path.startsWith("/dashboard")) return null;
  const info = pageInfo(dashboardAll, path);
  if (!info) return null;
  return (
    <div className={"trc-page-header" + (ownTitle ? " trc-page-header--compact" : "")} ref={ref}>
      <p className="trc-page-kicker">{[info.family, info.section, ownTitle ? info.title : ""].filter(Boolean).join(" · ")}</p>
      {ownTitle ? null : <h1 className="trc-page-title">{info.title}</h1>}
    </div>
  );
});

const Content = ({ children }) => (
  <div className="content">
    <PageHeader />
    {children}
  </div>
);

export default Content;
